<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h1>{{ newMessage }}</h1>
    <h1>Contact URL</h1>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data()
  {
      return{
          newMessage: ["not","gonna","show"]
      }
  },
  props: {
    msg: 
    {
     type: Array,
    required: true
  }
},

mounted()
{  
    //this.newMessage = this.newMessage.push(this.msg);
    //var item;

    // for(const [item,index] of this.newMessage.entries())
    // {
    //    (index == (this.newMessage.length - 1)) ? this.newMessage.push(this.msg) : null;
    //   alert(this.newMessage);
    // }
    // this.msg.forEach((element)=>{this.newMessage.push(element)});
    // this.newMessage.push(this.msg)

    this.newMessage.forEach((element,index) => {
       (index == (this.newMessage.length - 1)) ? this.msg.forEach((element)=>{this.newMessage.push(element)}) : null;
      alert(this.newMessage); 
    });

}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
